import { createApi } from "@reduxjs/toolkit/query/react";
import { customFetchBase } from "../../utils/API/fetchBaseQuery";
import { transformErrorResponse, transformSuccessResponse } from "../../utils/API/responseMiddleware";
import { transformRequest } from "../../utils/API/requestMiddleware";

// Create task API
const taskAPI = createApi({
    reducerPath: "taskAPI",
    baseQuery: customFetchBase,
    endpoints: (builder) => ({
        // Task management Endpoints

        // Add task 
        addTask: builder.mutation({
            query: (data) => ({
                url: "/Task/AddTask",
                method: 'POST',
                body: transformRequest(data),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        deleteTask: builder.mutation({
            query: (details) => ({
                url: `/Task/DeleteTask/?taskid=${details}`,
                method: 'DELETE',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        bulkUpdateTasks: builder.mutation({
            query: (data) => ({
                url: "/Task/BulkUpdateTasks",
                method: "POST",
                body: transformRequest(data),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        bulkDeleteTasks: builder.mutation({
            query: (data) => ({
                url: "/Task/BulkDeleteTasks",
                method: "POST",
                body: transformRequest(data),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getTaskById: builder.query({
            query: (TaskId) => ({
                url: `/Task/GetTaskByTaskId?TaskId=${TaskId}`,
                method: 'GET'
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),
        updateTask: builder.mutation({
            query: (data) => ({
                url: "/Task/UpdateBacklogTask",
                method: 'POST',
                body: transformRequest(data),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getTaskListPagination: builder.mutation({
            query: (data) => ({
                url: "/Task/GetTaskListPagination",
                method: 'POST',
                body: transformRequest(data),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getMyTaskListByProjectId: builder.mutation({
            query: (data) => ({
                url: "/Task/GetMYTaskListByProjectId",
                method: 'POST',
                body: transformRequest(data),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getTaskListForPlanningByProjectId: builder.mutation({
            query: (data) => ({
                url: "/Task/GetTaskListForPlanningByProjectId",
                method: 'POST',
                body: transformRequest(data),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        getAllProjectTaskList: builder.mutation({
            query: (data) => ({
                url: "/Task/GetAllProjectTaskList",
                method: 'POST',
                body: transformRequest(data),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        getAllTasksList: builder.mutation({
            query: (data) => ({
                url: "/Task/GetAllTasksList",
                method: 'POST',
                body: transformRequest(data),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        getAllTasksListWithPagination: builder.mutation({
            query: (data) => ({
                url: "/Task/GetAllTasksListWithPagination",
                method: 'POST',
                body: transformRequest(data),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        getAllTaskByPlanningTeamMember: builder.query({
            query: (planningId) => ({
                url: `Task/GetAllTaskByPlanningTeamMember?PlanningId=${planningId}`,
                method: 'GET'
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),

    })
})

// Extract hooks for easy access to various API requests 
export const {
    useAddTaskMutation,
    useDeleteTaskMutation,
    useBulkUpdateTasksMutation,
    useBulkDeleteTasksMutation,
    useLazyGetTaskByIdQuery,
    useUpdateTaskMutation,
    useGetTaskListPaginationMutation,
    useGetMyTaskListByProjectIdMutation,
    useGetTaskListForPlanningByProjectIdMutation,
    useGetAllProjectTaskListMutation,
    useLazyGetAllTaskByPlanningTeamMemberQuery,
    useGetAllTasksListMutation,
    useGetAllTasksListWithPaginationMutation,
} = taskAPI;

export default taskAPI;